import { initializeAnalytics, type Environment } from "@fullscript/fs-analytics";

import { isProduction, isStaging } from "@shared/utils/fullscriptEnv/fullscriptEnv";

let initialized = false;

const getFsAnalyticsEnvironment = (): Environment => {
  if (isProduction()) return "production";
  if (isStaging()) return "staging";

  return "dev";
};

/**
 * Initialize fs-analytics. This is idempotent - calling it multiple times is safe.
 * If a key is provided, it will be stored for future calls.
 * Subsequent calls can omit the key if it was previously stored.
 */
const initFsAnalytics = (): boolean => {
  let rudderstackJsFsaWriteKey: string;

  /**
   * Rudderstack write keys are publicly visible and have been moved here from their previous hardcoded locations in the define.mjs files.
   * Once Remix environment variables are implemented accross the app, we can remove this and use a window.ENV var instead.
   */
  if (isProduction()) {
    rudderstackJsFsaWriteKey = "3AUE7onO0U4QeKLba1iqgN6Eh28";
  } else {
    rudderstackJsFsaWriteKey = "3AUDusr65kwFmJrsVqahIb8Ojdc";
  }

  if (initialized) return true;

  initializeAnalytics(rudderstackJsFsaWriteKey, getFsAnalyticsEnvironment());
  initialized = true;

  return true;
};

export { initFsAnalytics };
